import React from 'react';
import store from '../../../../Store';
import {connect} from 'react-redux';
import getSite from "../../../../ajax/actions/sites/site_get";
import {withRouter} from "react-router";
import getsCacheIgnore from "../../../../ajax/actions/kepler-tools/cache_ignore_gets";


class FeatureBlockWorker extends React.Component {
    componentDidMount() {
        store.dispatch(getsCacheIgnore(this.props.match.params.id, this.props.organization_id));

        if(this.props.organization_id) {
            store.dispatch(getSite(this.props.match.params.id, this.props.organization_id));

        }
    }


    render() {
        return null
    }
}

function mapStateToProps(state) {
    let {organizationDashboard, getSite, getSites} = state;
    let {organization_id} = organizationDashboard.data;
    return {organizationDashboard, organization_id, getSite, getSites};
}

export default withRouter(connect(mapStateToProps)(FeatureBlockWorker));